import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { BolloVirtualePRModalComponent } from './bollo-virtuale-pr-modal';

export const BolloVirtualePRModalModule: string = ng
    .module('bollo-virtuale-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('bolloVirtualePrModal', BolloVirtualePRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/bollo-virtuale-pr-modal/bollo-virtuale-pr-modal.module.ts